import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('assets_sale')
export class AssetsSale {
    
    @PrimaryGeneratedColumn('increment', {
        name: 'asset_sale_id'
    })
    assetSaleId: number;

    @Column('int', {
        name:'asset_id'
    })
    assetId : number;

    @Column('varchar', {
        name:'approved_by'
    })
    approvedBy: string;

    @Column('varchar', {
        name:'asset_sale_cost'
    })
    assetSaleCost: string;

    @Column('varchar', {
        name:'status'
    })
    status: string;

    @Column('varchar', {
        name:'reason'
    })
    reason: string;

    @Column('boolean', {
        name:'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
}